export { default } from './shopProductSlice';
